import { Capacitor } from '@capacitor/core'

export function isNativePlatform() {
  return Capacitor.isNativePlatform()
}

export function platformName(): 'android' | 'web' {
  return Capacitor.isNativePlatform() ? 'android' : 'web'
}

export function defaultDeviceName() {
  return Capacitor.isNativePlatform() ? 'Android 设备' : '网页浏览器'
}
